"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnboardingCb = void 0;
const apolloComponents_1 = require("../generated/apolloComponents");
exports.useOnboardingCb = (skip) => {
    const { data: cbData } = apolloComponents_1.useCookbooksQuery({
        skip,
    });
    const cbYouOwn = cbData === null || cbData === void 0 ? void 0 : cbData.cookbooks.find(x => x.accessLevel === apolloComponents_1.CookbookAccessLevel.Owner);
    const { data: sectionData } = apolloComponents_1.useSectionsByCookbookIdQuery({
        variables: { cookbookId: cbYouOwn === null || cbYouOwn === void 0 ? void 0 : cbYouOwn.id },
        skip: !cbYouOwn,
        notifyOnNetworkStatusChange: true,
    });
    return {
        cookbook: cbYouOwn,
        section: sectionData === null || sectionData === void 0 ? void 0 : sectionData.sectionsByCookbookId[0],
    };
};
//# sourceMappingURL=useOnboardingCb.js.map